module.exports = __webpack_public_path__ + "img/dink-living-4.598206e2.jpeg";